/**
 * O contador de avisos não lidos do menu (E150.F1 — GUS-150, ADR-0102 §4), no portal e na equipe.
 *
 * O número é o `nao_vistos` da MESMA lista que a página de avisos mostra (BR-10). Relê ao trocar de
 * página e quando um aviso é marcado como lido (`EVENTO_AVISOS_ALTERADOS`). Falhou a leitura: o
 * menu fica sem número, em vez de mostrar um palpite.
 */
import { useEffect, useState } from 'react';
import type { AxiosInstance } from 'axios';
import { useLocation } from 'react-router-dom';

import { useApiClient } from '@/lib/api';
import { EVENTO_AVISOS_ALTERADOS, type AvisosData } from '@/lib/portal/avisos';

export function useAvisosNaoLidos(
  buscar: (client: AxiosInstance) => Promise<AvisosData>,
  ativo: boolean,
): number | null {
  const client = useApiClient();
  const { pathname } = useLocation();
  const [naoLidos, setNaoLidos] = useState<number | null>(null);
  const [vez, setVez] = useState(0);

  useEffect(() => {
    const reler = () => setVez((n) => n + 1);
    window.addEventListener(EVENTO_AVISOS_ALTERADOS, reler);
    return () => window.removeEventListener(EVENTO_AVISOS_ALTERADOS, reler);
  }, []);

  useEffect(() => {
    if (!ativo) {
      setNaoLidos(null);
      return;
    }
    let cancelado = false;
    buscar(client)
      .then((avisos) => {
        if (!cancelado) setNaoLidos(avisos.nao_vistos);
      })
      .catch(() => {
        if (!cancelado) setNaoLidos(null);
      });
    return () => {
      cancelado = true;
    };
  }, [ativo, buscar, client, pathname, vez]);

  return naoLidos;
}
